import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Login.module.css";
import { useLoginMutation } from "../../redux/slices/usersApiSlice";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials, clearData } from "../../redux/slices/authSlice";
import { toast } from "react-toastify";
import "react-toastify/ReactToastify.css";
import Mekke from "../../assets/pngs/mekke.jpg";
import Logo from '../../assets/svgs/tevhidlogo.svg'

const Login = () => {
  
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const { userInfo } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [login, { isLoading }] = useLoginMutation();

  useEffect(() => {
    if (userInfo) {
      navigate("/dashboard");
    }
  }, [navigate, userInfo]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      dispatch(clearData());
      const res = await login({ email, password }).unwrap();
      dispatch(setCredentials({ ...res }));
      navigate("/dashboard");
    } catch (error) {
      toast.error(
        error?.status === 429 ? error.data?.message : "Yanlış email veya şifre."
      );
    }
  };

  return (
    <section className={styles.container}>
      <div className={styles.background}>
        <img src={Mekke} alt="Background" className={styles.backgroundImage} />
        <div className={styles.overlay}></div>
      </div>
      <div className={styles.foregroundImage}>
        <div className={styles.auth}>
          <img src={Logo} alt="Logo" />
          <form onSubmit={handleLogin}>
            <input
              type="text"
              name="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="password"
              name="password"
              placeholder="Şifre"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button type="submit" disabled={isLoading}>
              {isLoading ? "Giriş yapılıyor..." : "Giriş yap"}
            </button>
          </form>
          {/* <p
            className={styles.loginmessage}
            onClick={() => navigate("/register")}
          >
            <span>Kayıt ol</span>
          </p> */}
        </div>
      </div>
    </section>
  );
};

export default Login;
